const filesContent = {
    "office":{
        "abc.txt":"Lorem ipsum",
        "bcd.txt":"Access denied",
        "readme.md":"Please consent to that we ...."    
    }
};
export default {
    cat: {
        execute(fileName,gamestate) {
            fileName = fileName.trim();
            gamestate.triedCat = true;
            gamestate.lastCat = gamestate.currentNode + "-" + fileName;
            let file = gamestate.nodes[gamestate.currentNode].files.filter(x => x.name == fileName)[0];            
            if (file) {
                return [{
                    lines: [file.content],
                    startAt: 1000
                }];
            } else {
                return [{
                    lines: ["File not found."],
                    startAt: 5000
                }];
            }
        }
    }
};